export const environment = {
    notificationsRootUrl: 'https://api-notifications.project1.epa.ohio.gov',
    clientID: 'fb1f63dd-9ab3-4ff5-ba16-242c4e45bc06',
    redirectURI: 'https://notifications.project1.epa.ohio.gov/'
};
